module.exports = __webpack_public_path__ + "static/0035-f02a80ebaa7bedca1cf13935711439ec.png";